<template>
  <div>
    <div class="contentRight2">
      <div class="head" style="font-size: 15px; color: #707070">
        <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>
            <a
              href="javascript:;"
              v-if="type == 'returnsPage'"
              @click="hrefOrder('/order/returnsAndRefunds')"
              >退货退款</a
            >
            <a href="javascript:;" v-else @click="hrefOrder('/order/offline')"
              >订单管理</a
            >
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            <a href="javascript:;" @click="hrefOrder('/order/orderDetails', '', type)"
              >订单详情</a
            >
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            <!-- <a href="javascript:;" @click="goBack(-1)">退货退款</a> -->
            退货退款
          </el-breadcrumb-item>
          <el-breadcrumb-item>退货入库</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- <div class="head" style="padding-top:25px;margin-top:20px">
        <el-date-picker
          size="small"
          v-model="businessTime"
          type="date"
          :disabled="disabled"
          placeholder="退货日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-select  :disabled="disabled" size="small" v-model="handlerId" placeholder="经手人">
          <el-option
            v-for="item in options"
            :key="item.shopWorkerUserId"
            
            :label="item.fullName"
            :value="item.shopWorkerUserId"
          ></el-option>
        </el-select>
      </div> -->
      <!-- 门店管理表格 -->
      <div class="content">
        <table class="table" width="100%" style="table-layout: fixed">
          <tr class="th">
            <td>商品名称</td>
            <td>单位</td>
            <td>可入库数</td>
            <td>良品入库</td>
            <td>不良破损出库量</td>
          </tr>
          <tr class="td" v-for="(item, index) in goodsList" :key="index">
            <td style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
              <div class="row alignCenter">
                <div>
                  <img
                    class="edit-item_img"
                    style="margin: 10px 10px"
                    :src="item.goodsImage"
                    alt
                  />
                </div>
                <div class="column">
                  <div class="edit-item_name">{{ item.goodsName }}</div>
                  <div class="edit-item_code">商品码：{{ item.goodsBarCode }}</div>
                </div>
              </div>
            </td>
            <td>{{ item.goodsUnit }}</td>
            <td>{{ item.refundCount }}</td>
            <td>
              <div v-show="item.putStorage == 1">
                <el-input
                  v-model="item.inputNum"
                  style="width: 100px"
                  @blur="inputChange(item, index)"
                ></el-input>
              </div>
              <div v-show="item.putStorage == 2">已全部入库</div>
            </td>
            <td>{{ Math.max(item.outputNum - item.inputNum, 0) }}</td>
          </tr>
        </table>
      </div>
      <div class="button">
        <div class="button-next row alignCenter">
          <el-button type="primary" @click="success" :disabled="disableds"
            >确定入库</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  enterRefundGoods,
  Shop_shopWorkers,
  toRefundOrderDetail,
  refundSelectProductList,
} from "../api";
export default {
  data() {
    return {
      type: "default", //面包屑导航 default:订单管理 returnPage:退货退款
      options: [],
      handlerId: "",
      businessTime: "",
      goodsList: [],
      mallOrderId: "",
      s: false,
      putStorage: "",
      disableds: false,
      type: "text",
    };
  },
  created() {
    this.mallOrderId = this.$route.query.mallOrderId;
    this.type = this.$route.query.type;
    this.goods();
    this.Shop_shopWorkers();
    this.toRefundOrderDetail();
  },
  methods: {
    toRefundOrderDetail() {
      toRefundOrderDetail({
        refundOrderId: this.$route.query.refundOrderId,
      }).then((res) => {
        if (res.code == 1) {
          this.businessTime = res.data.businessTime;
          this.handlerId = res.data.handlerId;
          if (res.data.businessTime && res.data.handlerId) {
            this.s = true;
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    inputChange(item, index) {
      console.log(item, index);
      let reg = /^[1-9]\d*$/;
      if (item.unitType == 1) {
        if (!reg.test(Number(item.inputNum))) {
          this.goodsList[index].inputNum = item.outputNum;
          this.$message.error("请输入正确的入库数量");
        }
      }
      if (Number(item.inputNum) > item.outputNum) {
        this.goodsList[index].inputNum = item.outputNum;
      } else if (Number(item.inputNum) == 0) {
        this.goodsList[index].inputNum = "";
        this.$message.error("入库数量不能为0");
      } else if (Number(item.inputNum) < 0) {
        this.goodsList[index].inputNum = item.outputNum;
        this.$message.error("请输入正确的入库数量");
      } else {
        this.goodsList[index].inputNum = Math.round(Number(item.inputNum) * 1000) / 1000;
      }
      this.update();
    },
    success() {
      var productJson = [];
      // if (!this.businessTime) {
      //   this.$message.error("请选择退货日期");
      //   return;
      // }
      // if (!this.handlerId) {
      //   this.$message.error("请选择经手人");
      //   return;
      // }
      for (let i in this.goodsList) {
        if (this.goodsList[i].putStorage == 1) {
          productJson.push({
            mallOrderProductId: this.goodsList[i].mallOrderProductId,
            // goodsNum: this.goodsList[i].buyCount,
            inputNum: this.goodsList[i].inputNum,
          });
        }
        // this.goodsList[i].num == null ||
        if (Number(this.goodsList[i].inputNum) < 0) {
          this.$message.error(
            "请输入商品：" + this.goodsList[i].goodsName + "的入库数量"
          );
          return;
        }
        if (Number(this.goodsList[i].inputNum) == 0) {
          this.$message.error(this.goodsList[i].goodsName + "的入库数量不能为0");
          return;
        }
      }
      enterRefundGoods({
        refundOrderId: this.$route.query.refundOrderId,
        // businessTime: this.getTime(),
        productJson: JSON.stringify(productJson),
      }).then((res) => {
        if (res.code == 1) {
          this.$message({
            type: "success",
            message: "入库成功",
          });
          this.$router.push("/order/offline");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    Shop_shopWorkers(item) {
      Shop_shopWorkers({
        pageSize: 9999,
        pageNumber: 1,
      }).then((res) => {
        this.options = res.data.pager.list;
      });
    },
    goods(item) {
      var mallOrderId = this.$route.query.mallOrderId;
      this.goodsList = [];
      //商品列表
      refundSelectProductList({
        mallOrderId: mallOrderId,
        productSaleStatus: 1,
      }).then((res) => {
        console.log(res, "商品列表哦");
        this.goodsList = res.data;
        var goodsList = this.goodsList;
        this.disableds = goodsList.every((item) => {
          return item.refundCount == item.inputNum;
        });
        for (let j in goodsList) {
          goodsList[j].num = null;
          if (goodsList[j].refundCount == goodsList[j].inputNum) {
            goodsList[j].putStorage = 2;
          } else {
            goodsList[j].putStorage = 1;
          }
        }
      });
    },
    update() {
      console.log("更新");
      var arr = this.goodsList;
      this.goodsList = "";
      this.goodsList = arr;
    },
    hrefOrder(path, query, type) {
      if (path == "/order/orderDetails") {
        query = this.mallOrderId;
      }
      this.$router.push({ path: path, query: { name: query, type: type } });
    },
    goBack(num) {
      this.$router.go(num);
    },
  },
};
</script>

<style scoped>
.button {
  position: fixed;
  bottom: 0;
  width: calc(100vw - 217px);
  padding: 30px;
  background: #fff;
  border-top: 1px solid #eee;
}
.button-next {
  float: right;
  margin-right: 50px;
}
.edit-item_maxPrice {
  color: #999999;
  font-size: 12px;
  margin-top: 10px;
}
.edit-item > .row {
  padding-bottom: 20px;
}
.edit-item:not(:first-child) {
  margin-top: 30px;
}
.edit-item {
  border-bottom: 1px solid #eee;
}
.edit-item_code {
  color: #999;
  margin-top: 15px;
}
.edit-item_name {
  color: #333333;
}
.edit-item_img {
  height: 65px;
  width: 65px;
  margin-right: 20px;
}
.editCom {
  max-height: 500px;
  overflow-y: scroll;
  margin: 30px;
  font-size: 14px;
  color: #666666;
}
.th {
  background: #f8f8f8;
  padding: 15px;
  height: 40px;
  font-size: 14px;
  color: #909399;
  font-weight: 600;
  line-height: 40px;
}

.th td {
  font-size: 14px;
  border-bottom: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
  text-align: center;
}
.th td:first-child {
  text-align: left;
  padding-left: 17px;
}
.th td:last-child {
  text-align: right;
  padding-right: 28px;
}
td {
  font-size: 14px;
  padding: 0;
  margin: 0;
  vertical-align: middle;
  /* width: 25%; */
}
table {
  border: 0;
  border-collapse: 0;
  border-spacing: 0;
  font-size: 14px;
}
.td td {
  height: 55px;
  border-bottom: 1px solid #ebeef5;
  text-align: center;
  word-break: keep-all; /* 不换行 */
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
  text-overflow: ellipsis; /* 当对象内文本溢出时显示省略标记(...) ；需与overflow:hidden;一起使用*/
}

.td td:first-child {
  text-align: left;
  padding-left: 17px;
}
.td td:last-child {
  padding-right: 30px;
  text-align: right;
}
.table {
  width: 100%;
  font-size: 12px;
}
.content {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  /* padding: 30px; */
  color: #606266;
  font-size: 14px;
}
.head {
  box-sizing: border-box;
  padding: 14px 25px;
  background: #f8f8f8;
  width: 100%;
}
</style>
